/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Sc_MultiInputs */

const en_pc_tut_sc_multi = /** @type {(inputs: Pc_Tut_Sc_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-select pages`)
};

const zh_pc_tut_sc_multi = /** @type {(inputs: Pc_Tut_Sc_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多选页面`)
};

/**
* | output |
* | --- |
* | "Multi-select pages" |
*
* @param {Pc_Tut_Sc_MultiInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_sc_multi = /** @type {((inputs?: Pc_Tut_Sc_MultiInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Sc_MultiInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_sc_multi(inputs)
	return zh_pc_tut_sc_multi(inputs)
});
export { pc_tut_sc_multi as "pc.tut.sc.multi" }